import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Text, View, Pressable, Animated } from 'react-native';
import { Hr, Icon, sectionListStyles } from 'LocalGluons';
import { noop } from 'Utils';

import { CachedImage } from 'LocalGluons/components/CachedImage';
import baseStyles from './ChannelOrderListItem.jss';

const MIN_IMAGE_SIZE = 20;

const formatIndex = (index) => {
    const value = index + 1;
    let result = String(value);

    if (value < 10) {
        result = `0${result}`;
    }

    if (value < 100) {
        result = `0${result}`;
    }

    return result;
};

const ChannelOrderListItem = ({
    item,
    drag,
    disableMove,
    isActive,
    onNumberPress,
    testID,
    isLast
}) => {
    const { logoUrl, name } = item;

    return (
        <View
            style={[
                baseStyles.outerItemContainer,
                isActive && baseStyles.outerItemContainerActive,
                isLast && baseStyles.outerItemContainerLast
            ]}
            testID={testID}
        >
            <Hr style={baseStyles.itemDivider} />
            <View style={baseStyles.innerItemContainer}>
                <Pressable
                    style={baseStyles.itemNumber}
                    onPress={onNumberPress}
                    testID={`${testID}_set_position`}
                >
                    <Text style={baseStyles.itemNumberText}>{formatIndex(item.index)}</Text>
                </Pressable>
                <View style={baseStyles.logoNameContainer}>
                    <CachedImage
                        style={{
                            minWidth: MIN_IMAGE_SIZE * 2,
                            minHeight: MIN_IMAGE_SIZE
                        }}
                        resizeMode="contain"
                        source={{ uri: logoUrl }}
                    />
                    <Text
                        style={[sectionListStyles.itemName, baseStyles.itemName]}
                        numberOfLines={1}
                    >
                        {name}
                    </Text>
                </View>
                {!disableMove && (
                    <Pressable onLongPress={drag}>
                        <Icon
                            style={baseStyles.dragHandler}
                            name="drag_handle"
                            testID={`${testID}_drag`}
                        />
                    </Pressable>
                )}
            </View>
            <Hr style={baseStyles.itemDivider} />
        </View>
    );
};

ChannelOrderListItem.defaultProps = {
    disableMove: false,
    onNumberPress: noop
};

ChannelOrderListItem.propTypes = {
    item: PropTypes.shape({
        logoUrl: PropTypes.string,
        name: PropTypes.string,
        index: PropTypes.number
    }).isRequired,
    drag: PropTypes.func.isRequired,
    isActive: PropTypes.bool.isRequired,
    disableMove: PropTypes.bool,
    onNumberPress: PropTypes.func,
    testID: PropTypes.string.isRequired
};

export { ChannelOrderListItem };
